import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';

export const ImageContainer = styled.img`
	width: 100%;
	height: 240px;
	object-fit: contain;
	object-position: center;
	border-radius: 12px;
`;

export const ImageOverlay = styled.div`
	position: absolute;
	width: 100%;
	height: 240px;
	top: 0;
	border-radius: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	opacity: 0;
	transition: 0.3s;

	&:hover {
		opacity: 1;
		background-color: rgba(255, 255, 255, 0.5);
	}
`;

export const VehicleImagesContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	padding-top: 16px;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		grid-template-columns: 1fr;
	}
`;

export const UploadImagesButton = styled.button`
	width: 100%;
	height: 240px;
	background-color: transparent;
	cursor: pointer;
	border: 2px dashed ${({ theme }) => theme.colors.primary.medium};
	border-radius: 12px;
	font-size: 48px;
	transition: background-color 0.3s;

	&:hover {
		background-color: ${({ theme }) => theme.colors.primary.lighter};
	}
`;
